export default {"src":"/_next/static/media/VideoGif3.74ea3583.gif","height":543,"width":800,"blurWidth":0,"blurHeight":0};